var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quad-pack"},[_c('div',{directives:[{name:"resize",rawName:"v-resize:throttle",value:(_vm.resized),expression:"resized",arg:"throttle"}],ref:"root",staticClass:"root"})])
}
var staticRenderFns = []

export { render, staticRenderFns }